(function() {
  document.addEventListener('click', function(e) {
    var link = e.target.closest('[data-portal-link]');
    if (!link) return;
    if (typeof window.gtag !== 'function') return;

    window.gtag('event', 'portal_nav_click', {
      link_name: link.dataset.portalLink,
      link_location: link.dataset.portalSurface || 'unknown',
      link_url: link.href || ''
    });
  }, true);

  // Account sidebar "My Favorites" (FAVTRACK 2026-10-23). The link has no data-portal-link, so
  // portal_nav_click never fires for it. Same params as mega_nav_click (assets/dtf-cta-tracking.js).
  // Phones open the same .mp-nav__link inside the sidebar drawer, so one listener covers both.
  // Event name is a pinned contract (the GA Chrome app reads it): do not rename.
  document.addEventListener('click', function(e) {
    var link = e.target.closest('.mp-nav__link');
    if (!link) return;
    var url = link.getAttribute('data-url') || '';
    var label = link.getAttribute('data-label') || '';
    if (url.indexOf('view=favorites') < 0 && !/\bfavorites\b/i.test(label)) return;
    if (typeof window.gtag !== 'function') return;
    var mh = document.querySelector('.mp-mobile-header');
    var drawer = !!(mh && getComputedStyle(mh).display !== 'none');
    window.gtag('event', 'account_sidebar_favorites_click', {
      cta_location: drawer ? 'account_sidebar_drawer' : 'account_sidebar',
      cta_label: ('Account Sidebar: ' + (label || (link.textContent || '').replace(/\s+/g, ' ').trim())).slice(0, 100),
      cta_destination: url,
      environment: window.Shopify && window.Shopify.theme && window.Shopify.theme.role === "main" ? "production" : "staging"
    });
  }, true);

  document.addEventListener('click', function(e) {
    var el = e.target.closest('[data-portal-action]');
    if (!el) return;
    if (typeof window.gtag !== 'function') return;
    window.gtag('event', 'portal_action_click', {
      action_name: el.dataset.portalAction,
      tab_location: el.dataset.portalTab || 'unknown',
      link_url: el.href || ''
    });
  }, true);
})();
